
import React, { useEffect } from "react";
import {
  Navbar,
  MobileNav,
  Typography,
  Button,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Avatar,
  Card,
  IconButton,
} from "@material-tailwind/react";
import {
  CubeTransparentIcon,
  UserCircleIcon,
  CodeBracketSquareIcon,
  Square3Stack3DIcon,
  ChevronDownIcon,
  Cog6ToothIcon,
  InboxArrowDownIcon,
  LifebuoyIcon,
  PowerIcon,
  RocketLaunchIcon,
  Bars2Icon,
} from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";
// profile menu component
import { useAuth } from "../auth/AuthControl";
const profileMenuItems = [
  {
    label: "My Profile",
    icon: UserCircleIcon,
  },
  {
    label: "Edit Profile",
    icon: Cog6ToothIcon,
  },
  {
    label: "Inbox",
    icon: InboxArrowDownIcon,
  },
  {
    label: "Help",
    icon: LifebuoyIcon,
  },
  {
    label: "Sign Out",
    icon: PowerIcon,
  },
];
 
function ProfileMenu() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
 
  const closeMenu = () => setIsMenuOpen(false);
 
  return (
    <Menu open={isMenuOpen} handler={setIsMenuOpen} placement="bottom-end">
      <MenuHandler>
        <Button
          variant="text"
          color="blue-gray"
          className="flex items-center gap-1 rounded-full py-0.5 pr-2 pl-0.5 lg:ml-auto"
        >
          <Avatar
            variant="circular"
            size="sm"
            alt="tania andrew"
            className="border border-gray-900 p-0.5"
            src="data:image/png;base64,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"
          />
          <ChevronDownIcon
            strokeWidth={2.5}
            className={`h-3 w-3 transition-transform ${
              isMenuOpen ? "rotate-180" : ""
            }`}
          />
        </Button>
      </MenuHandler>
      <MenuList className="p-1">
        {profileMenuItems.map(({ label, icon }, key) => {
          const isLastItem = key === profileMenuItems.length - 1;
          return (
            <MenuItem
              key={label}
              onClick={closeMenu}
              className={`flex items-center gap-2 rounded ${
                isLastItem
                  ? "hover:bg-red-500/10 focus:bg-red-500/10 active:bg-red-500/10"
                  : ""
              }`}
            >
              {React.createElement(icon, {
                className: `h-4 w-4 ${isLastItem ? "text-red-500" : ""}`,
                strokeWidth: 2,
              })}
              <Typography
                as="span"
                variant="small"
                className="font-normal"
                color={isLastItem ? "red" : "inherit"}
              >
                {label}
              </Typography>
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
}
 
// nav list menu
const navListMenuItems = [
  {
    title: "Lead",
    description:
      "นำทางไปหน้า Lead ทรัพย์",
  },
  {
    title: "Help Post (ช่วยขาย)",
    description:
      "นำทางไปหน้า ให้ postperty ช่วยขายทรัพย์",
  },
  {
    title: "(All post) โพสต์ทั้งหมด",
    description:
      "นำทางไปหน้าแสดงโพสต์ทั้งหมดที่มี"
  },
];
 
function NavListMenu() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
 
  const renderItems = navListMenuItems.map(({ title, description }) => (
    <a href="#" key={title}>
      <MenuItem>
        <Typography variant="h6" color="blue-gray" className="mb-1 font-main">
          {title}
        </Typography>
        <Typography variant="small" color="gray" className="font-normal font-main">
          {description}
        </Typography>
      </MenuItem>
    </a>
  ));
 
  return (
    <React.Fragment>
      <Menu allowHover open={isMenuOpen} handler={setIsMenuOpen}>
        <MenuHandler>
          <Typography as="a" href="#" variant="small" className="font-normal">
            <MenuItem className="hidden items-center gap-2 font-medium text-blue-gray-900 lg:flex lg:rounded-full">
              <Square3Stack3DIcon className="h-[18px] w-[18px] text-blue-gray-500" />{" "}
              Pages{" "}
              <ChevronDownIcon
                strokeWidth={2}
                className={`h-3 w-3 transition-transform ${
                  isMenuOpen ? "rotate-180" : ""
                }`}
              />
            </MenuItem>
          </Typography>
        </MenuHandler>
        <MenuList className="hidden w-[36rem] grid-cols-7 gap-3 overflow-visible lg:grid">
          <Card
            color="blue"
            shadow={false}
            variant="gradient"
            className="col-span-3 grid h-full w-full place-items-center rounded-md"
          >
            <RocketLaunchIcon strokeWidth={1} className="h-28 w-28" />
          </Card>
          <ul className="col-span-4 flex w-full flex-col gap-1">
            {renderItems}
          </ul>
        </MenuList>
      </Menu>
      <MenuItem className="flex items-center gap-2 font-medium text-blue-gray-900 lg:hidden">
        <Square3Stack3DIcon className="h-[18px] w-[18px] text-blue-gray-500" />{" "}
        Pages{" "}
      </MenuItem>
      <ul className="ml-6 flex w-full flex-col gap-1 lg:hidden">
        {renderItems}
      </ul>
    </React.Fragment>
  );
}
 
// nav list component
const navListItems = [
  {
    label: "Account",
    icon: UserCircleIcon,
  },
  // {
  //   label: "Blocks",
  //   icon: CubeTransparentIcon,
  // },
  {
    label: "Docs",
    icon: CodeBracketSquareIcon,
  },
];
 
function NavList() {
  return (
    <ul className="mt-2 mb-4 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center ">
      <NavListMenu />
      {navListItems.map(({ label, icon }, key) => (
        <Typography
          key={label}
          as="a"
          href="#"
          variant="small"
          color="gray"
          className="font-medium text-blue-gray-500"
        >
          <MenuItem className="flex items-center gap-2 lg:rounded-full">
            {React.createElement(icon, { className: "h-[18px] w-[18px]" })}{" "}
            <span className="text-gray-900"> {label}</span>
          </MenuItem>
        </Typography>
      ))}
    </ul>
  );
}
 
export function ComplexNavbar() {
  const {isAuthenticated , login , logout} = useAuth()
  const [isNavOpen, setIsNavOpen] = React.useState(false);
 
  const toggleIsNavOpen = () => setIsNavOpen((cur) => !cur);
  const currentUrl = window.location.href;

  const hiddenURLs = ['http://localhost:3000/auth/login' , "https://sudo.postperty.com/auth/login"]
  React.useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setIsNavOpen(false),
    );
  }, []);
 
  return (
    <div className={hiddenURLs.includes(currentUrl) ? "hidden" : "  w-full mx-auto fixed right-0 top-0  max-w-screen-lg p-2 h-max lg:pl-6 bg-white md:hidden  z-50 md:right-2 md:top-1.5"}>
      <div className="relative mx-auto flex items-center justify-between text-blue-gray-900 ">
        <Typography
          as="a"
          href="#"
          className="mr-4 ml-2 cursor-pointer py-1.5 font-medium font-main"
        >
          ระบบบริหารจัดการ
        </Typography>
        <div className="hidden lg:block">
          <NavList />
        </div>
        <IconButton
          size="sm"
          color="blue-gray"
          variant="text"
          onClick={toggleIsNavOpen}
          className="ml-auto mr-2 lg:hidden"
        >
          <Bars2Icon className="h-6 w-6" />
        </IconButton>
        
        <Button size="sm" variant="text" onClick={()=>logout()}>
          <span className="text-red-500">Logout</span>
        </Button>
        
        <ProfileMenu />
      </div>
      <MobileNav open={isNavOpen} className="overflow-scroll">
        <NavList />
      </MobileNav>
    </div>
  );
}